export default {
  ERROR_MSG: 'Something went wrong',
  CARE_PROGRAM_TYPE: {
    BILYPSA: 'bilypsa',
    AKUMENTIS: 'akumentis',
    ANAYA: 'anaya',
    PROSTATE: 'prostate',
    LIVER_FOREVER_PROGRAM: 'liver-forever-program',
    VIEMAX: 'viemax-program',
    NIVOLUMAB: 'nivolumab',
    DIASENS: 'diasens',
    GOODFLIP: 'goodflip',
    GLP: 'glp',
    GLUCOLIVE: 'glucolive',
  },
  // CGM Types - separate from PSP programs
  CGM_TYPE: {
    DIASENS: 'diasens',
    GOODFLIP: 'goodflip',
    GLUCOLIVE: 'glucolive',
  },
  MIN_AGE: 18,
  MAX_AGE: 100,
  PSP_USER_FROM: 'PSP',
  CGM_USER_FROM: 'GoodFlip',
  GLP_USER_FROM: 'GLP',
  GOOD_FLIP_SOURCE: 'GoodFlip',
  REJECTED_STATUS: 'Rejected',
}
export const DOCUMENT_TYPE_TITLES = {
  dp: 'Doctor Prescription',
  pi: 'Purchase Invoice',
}
export const DOWNLOAD_APP_URL = 'https://dl.mytatva.in/'

export const TERMS_URL = 'https://shop.goodflip.in/pages/terms-conditions'
export const POLICY_URL = 'https://shop.goodflip.in/pages/privacy-policy'

/** Allows only Latin letters and spaces (empty string passes). */
export const NAME_LETTERS_AND_SPACES_PATTERN = /^[A-Za-z\s]*$/
